<div class="w-full mx-auto rounded-lg max-h-[90vh] flex flex-col">
  <div class="py-2 px-4 flex-shrink-0">
    <div class="titre3 dark:text-white">{{ (data.mode === 'ajouter' ? 'DIFFUSION.ADD_DIFFUSION_MULTIPLE' : 'DIFFUSION.EDIT_DIFFUSION_MULTIPLE') | translate }}</div>
  </div>

  <div class="flex-1 overflow-y-auto p-4 min-h-0">
    <div class="mb-4">
      <label class="block mb-2 text-sm font-medium text-gray-700 dark:text-white">
        {{ 'DIFFUSION.TITRE' | translate }}
        <span class="text-red-600">*</span>
      </label>
      <input type="text" [(ngModel)]="titre"
        placeholder="{{ 'DIFFUSION.TITRE' | translate }}"
        class="w-full p-2 border rounded">
      </div>

      <div class="mb-4">
        <label class="block mb-2 text-sm font-medium text-gray-700 dark:text-white">
          {{ 'DIFFUSION.SELECT_SCORM_PACKAGES' | translate }}
          <span class="text-red-600">*</span>
        </label>
        <div class="flex gap-2">
          <mat-select title="scormPackageDisponible"
            class="w-full p-2 border border-gray-300 rounded dark:text-white"
            panelClass="scorm-package-select-panel"
            panelHeight="300"
            (selectionChange)="onAjouterPackage($event, {})"
            [value]="">
            <mat-option>
              <ngx-mat-select-search [formControl]="scormPackageFilterCtrl"
                [placeholderLabel]="'DIFFUSION.SEARCH' | translate"
                [noEntriesFoundLabel]="'DIFFUSION.NO_RESULTS' | translate">
              </ngx-mat-select-search>
            </mat-option>
            <mat-option value="">{{ 'DIFFUSION.SELECT_SCORM_PACKAGES' | translate }}</mat-option>
            @for (package of filteredScormPackages | async; track package) {
              <mat-option [value]="package.scormPackageId">
                {{ getPackageTitle(package) }}
              </mat-option>
            }
          </mat-select>
        </div>
      </div>

      @if (scormPackagesSelectionnes.length > 0) {
        <div class="mt-3">
          <h4 class="titre4">{{ 'DIFFUSION.SELECTED_PACKAGES' | translate }}:</h4>
          <ul cdkDropList (cdkDropListDropped)="onDeplacerPackage($event)" class="list-none p-0">
            @for (package of scormPackagesSelectionnes; track package) {
              <li
                cdkDrag
                class="flex items-center justify-between py-1 cursor-move">
                <span class="flex items-center gap-2">
                  <span class="text-gray-400">&#9776;</span>
                  {{ getPackageTitle(package) }}
                </span>
                <button type="button" (click)="onRetirerPackage(package.scormPackageId)" class="ml-2 text-rougeNovo">
                  {{ 'DIFFUSION.REMOVE' | translate }}
                </button>
              </li>
            }
          </ul>
        </div>
      }

      <div class="mb-4">
        <label class="block mb-2 text-sm font-medium text-gray-700 dark:text-white">
          {{ 'DIFFUSION.SELECT_LANGUAGE' | translate }}
          <span class="text-red-600">*</span>
        </label>
        <select title="langue" [(ngModel)]="langueSelectionnee"
          class="w-full p-2 border rounded">
          <option [ngValue]="null">{{ 'DIFFUSION.SELECT_LANGUAGE' | translate }}</option>
          <option value="fr">{{ 'DIFFUSION.LANGUAGE_FR' | translate }}</option>
          <option value="en">{{ 'DIFFUSION.LANGUAGE_EN' | translate }}</option>
          <option value="es">{{ 'DIFFUSION.LANGUAGE_ES' | translate }}</option>
        </select>
      </div>
    </div>

    <div class="py-2 px-4 border-t border-gray-300 dark:border-gray-600 flex-shrink-0 flex justify-end">
      <button (click)="onCancel()" type="button" class="btn-secondary-novo">
        {{ 'DIFFUSION.CANCEL' | translate }}
      </button>
      <button [disabled]="scormPackagesSelectionnes.length === 0 || !langueSelectionnee || !titre.trim()"
        (click)="onSubmit()" type="submit"
        class="btn-primary-novo disabled:opacity-50 disabled:cursor-not-allowed">
        {{ 'DIFFUSION.SAVE' | translate }}
      </button>
    </div>
  </div>
